type IsGuestLockedOutArgs = Readonly<{
  hasAccess: boolean | null | undefined;
  pageCount: number;
  hasPasswordProtectedPage: boolean;
}>;

/**
 * True when a guest is blocked from seeing any event content because at least
 * one page is password-protected (and not because pages are merely hidden or
 * the event has no pages at all).
 *
 * Callers pass `hasUnlocked` (event-wide session unlock) or `canAccessPage`
 * (per-page access) as `hasAccess` — both reduce to the same yes/no.
 */
export const isGuestLockedOut = ({ hasAccess, pageCount, hasPasswordProtectedPage }: IsGuestLockedOutArgs): boolean => hasPasswordProtectedPage && !hasAccess && pageCount === 0;
